const Section = ({ children, backgroundColor = undefined }) => {
  return (
    <div className="section-wrapper" style={{ backgroundColor }}>
      <div className="section">{children}</div>
    </div>
  );
};

export default Section;
